import { ReferenceData } from '~/data/useGradeConversionPageProps';

export type EducationLevelOption = { id: string; name: string };
export type CountryOption = { code: string; label: string };

export function mapEducationLevels(educationLevels?: ReferenceData['educationLevels']): EducationLevelOption[] {
  if (!educationLevels) {
    return [];
  }

  return Object.entries(educationLevels).map(([id, data]) => ({
    id,
    name: data.code ? `${data.name} (${data.code})` : data.name,
  }));
}

export function mapCountries(countries?: ReferenceData['countries']): CountryOption[] {
  if (!countries) {
    return [];
  }

  return Object.entries(countries).map(([code, data]) => ({
    code,
    label: data.countryLabel,
  }));
}
